import React, { useCallback } from 'react'
import { Calendar, useStaticState } from '@material-ui/pickers'
import { observer } from 'mobx-react-lite'
import useStore from 'hooks/useStore'
import { getDate, isSameDay } from 'date-fns'

function CalendarView() {
	const store = useStore()

	const { pickerProps } = useStaticState({
		value: store.date,
		onChange: store.handleDateChange,
	})

	const shouldDisableDate = useCallback(
		day => {
			const isSame = isSameDay(day, new Date())
			const isEnable = store.enable.includes(getDate(day))
			return !isSame && !isEnable
		},
		[store.enable]
	)

	return (
		<Calendar
			{...pickerProps}
			disableFuture
			onMonthChange={store.handleMonthChange}
			shouldDisableDate={shouldDisableDate}
		/>
	)
}

export default observer(CalendarView)
